// Neue Adressen (domeinApp.nl.ts). Deutsche Fassung.
export const appDomeinDe = {
    company: {
        title: 'Firmenangaben',
        kvk: 'Handelsregister (KvK) {kvk}',
        contact: 'Kontakt',
        where: 'Die App ist unter {app} und das Board an der Wand unter {board}. Melde dich nur unter {app} an.',
    },
    /** Oude beginscherm-app van f.amumin.com: weg, en {app} opnieuw op het beginscherm. */
    homeScreen: 'Hattest du AMUMIN auf dem Home-Bildschirm? Entferne das alte Symbol und lege {app} neu auf den Home-Bildschirm. Auf iPhone oder iPad funktionieren Benachrichtigungen nur vom Home-Bildschirm aus.',
    push: {
        title: 'Benachrichtigungen sind in diesem Browser aus',
        body: 'AMUMIN ist jetzt unter amumin.app. Benachrichtigungen schaltet man pro Adresse ein, deshalb muss dieser Browser es noch einmal tun. Möchtest du hier wieder Benachrichtigungen bekommen?',
        action: 'Benachrichtigungen einschalten',
        later: 'Nicht jetzt',
        done: 'Benachrichtigungen sind wieder an.',
        denied: 'Dieser Browser blockiert Benachrichtigungen. Du kannst sie in den Browser-Einstellungen erlauben.',
    },
};
//# sourceMappingURL=domeinApp.de.js.map